import { render, staticRenderFns } from "./CustomButton.vue?vue&type=template&id=618a5d90&scoped=true&"
import script from "./CustomButton.vue?vue&type=script&lang=ts&"
export * from "./CustomButton.vue?vue&type=script&lang=ts&"
import style0 from "./CustomButton.vue?vue&type=style&index=0&id=618a5d90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618a5d90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
